import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Translate from 'react-translate-component';
import { Button } from 'antd';

import { generateFileUrl, generateMetroFileUrl } from 'constants/urls';

export default class DocumentDownload extends Component {
    static propTypes = {
        document: PropTypes.object.isRequired,
        onDownloadStart: PropTypes.func
    };

    componentDidMount() {
        if (this.props.onDownloadStart) {
            this.startDownload();
            this.props.onDownloadStart();
        }
    }

    startDownload = () => {
        this.link.click();
    }

    render() {
        const isMetro = this.props.document.metro;
        const url = isMetro ? generateMetroFileUrl(this.props.document) : generateFileUrl(this.props.document);

        return (
            <a href={url} download ref={node => this.link = node}>
                <Button>
                    <Translate content="documents.download" />
                </Button>
            </a>
        );
    }
}
